/** Shared background color presets for all website-builder section panels. */
export const PANEL_PREDEFINED_COLORS = [
  '#5E19A1',
  '#FF9736',
  '#079271',
  '#1B5BFF'
] as const;

export type PanelPredefinedColor = (typeof PANEL_PREDEFINED_COLORS)[number];

export function isPredefinedPanelColor(color: string | null | undefined): boolean {
  if (!color) {
    return false;
  }
  return (PANEL_PREDEFINED_COLORS as readonly string[]).includes(color);
}

export function normalizePickerHexColor(color: string | any): string {
  let hexColor: string;
  if (typeof color === 'string') {
    hexColor = color;
  } else if (color && typeof color === 'object' && 'hex' in color) {
    hexColor = color.hex;
  } else {
    hexColor = String(color);
  }
  if (!hexColor.startsWith('#')) {
    hexColor = `#${hexColor}`;
  }
  return hexColor;
}
